/**
 * FileEditorApp Definition
 */

import { FileCode } from '@phosphor-icons/react';
import type { AppDefinition } from '../../types/apps';

const FileEditorAppDefinition: AppDefinition = {
  appId: 'file-editor',
  name: 'File Editor',
  description: 'Edit files with live CRDT sync and syntax highlighting',
  icon: {
    type: 'component',
    component: FileCode,
    componentProps: {
      weight: 'duotone',
      color: '#3b82f6',
    },
  },
  version: '1.0.0',
  component: 'file-editor',
  entityTypes: [
    'File.Code.*',
    'File.Data.*',
    'File.Document.Text',
    'File.Document.Markdown',
    'File.Audio.*',
    'File.Archive.*',
  ],
  requiresProps: true,
  requiresEntity: true,
};

export default FileEditorAppDefinition;
